// Placeholder for IntegrationsStore actions
import { flow } from 'mobx-state-tree';
import { api_activate_integration, api_get_integrations /*, api_create_integration, api_update_integration, api_delete_integration*/ } from '../../../queries/integrations'; // Assuming API queries

export const integrationsStoreActions = self => ({
  set(fieldName, value) {
    self[fieldName] = value;
  },

  // Load integrations from an API
  async loadIntegrations() {
    if (!self.merchantId) {
      console.warn("loadIntegrations: merchantId is not available. Skipping API call.");
      // self.loading is not set to true yet, so no need to set it to false here if we return early.
      return;
    }
    self.set('loading', true);
    try {
      const response = await api_get_integrations(self.merchantId, self.token);
      if (response && response.data) {
        self.set('integrations', response.data.data); 
      }
    } catch (error) {
      console.error("Failed to load integrations", error);
      // Handle error appropriately (e.g., show notification to the user)
      // Example: self.root.notificationsStore.addNotification('Failed to load integrations.', 'error');
    } finally {
      self.set('loading', false);
    }
  },

  async activateIntegration(payload) {
    if (!self.merchantId) {
      console.warn("activateIntegration: merchantId is not available. Skipping API call.");
      return;
    }
    self.set('loading', true);
    try {
      const response = await api_activate_integration(self.merchantId, payload, self.token);
      if (response && response.data) {
        self.loadIntegrations();
        return response.data;
      }
    } catch (error) {
      console.error("Failed to activate integration", error);
      return error;
    } finally {
      self.set('loading', false);
    }
  },
  set(key, value) {
    self[key] = value;
  }
});
